import { render } from "./mobile_fr3_duo.vue?vue&type=template&id=172fb9d6&scoped=true"
import script from "./mobile_fr3_duo.vue?vue&type=script&lang=js"
export * from "./mobile_fr3_duo.vue?vue&type=script&lang=js"

import "./mobile_fr3_duo.vue?vue&type=style&index=0&id=172fb9d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172fb9d6"]])

export default __exports__